import React from 'react'

const BluePlus = props => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M8.967 14.801a1.033 1.033 0 0 0 2.065 0v-3.768H14.8a1.032 1.032 0 1 0 0-2.065h-3.768V5.199a1.032 1.032 0 1 0-2.065 0v3.769H5.199a1.032 1.032 0 1 0 0 2.065h3.768V14.8z" fill="#0350A2"/>
    </svg>
)

export default BluePlus
